import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import Swal from 'sweetalert2';
import CustomTable from '../../helpers/custom-table'
import { catchError } from '../../helpers/catch-error'
import { NavLink } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';


const Canceled = () => {
  const navigate = useNavigate();


  var columns = React.useMemo(
    () => [
      {
        accessorFn: row => <a
          className={row.is_updated == 1 ? "fw-bold text-shadow text-danger" : ""}
          href={"/admin/work-order/" + row.work_order_id} >{row.work_order_no}</a>,
        id: "work_order_id",
        cell: info => info.getValue(),
        header: () => "ID",
        footer: props => props.column.id,
        enableColumnFilter: false,
      },
      {
        accessorFn: row => row.wo_creation_date + "_" + row.wo_creation_date_days + " days",
        id: "wo_creation_date",
        cell: ({ getValue }) => (
          <span>
            <ul className="table-ul">
              {(getValue().split("_")).map((p, index) => (
                <li key={index}>{p}</li>
              ))}
            </ul>
          </span>
        ),
        header: () => "Date",
        footer: props => props.column.id
      },
      {
        accessorFn: row => row.close_date + "_" + row.closed_by,
        id: "wo_creation_date",
        cell: ({ getValue }) => (
          <span>
            <ul className="table-ul">
              {(getValue().split("_")).map((p, index) => (
                <li key={index}>{p}</li>
              ))}
            </ul>
          </span>
        ),
        header: () => "Closed Date/By",
        footer: props => props.column.id
      },
      {
        accessorFn: row => row.patient_last_name + " " + row.patient_first_name,
        id: "lastName",
        cell: info => info.getValue(),
        header: () => "Patient",
        footer: props => props.column.id
      },
      {
        accessorKey: "client_company_name",
        header: "Client",
        footer: props => props.column.id
      },
      {
        accessorKey: "facility_name",
        header: "Facility",
        footer: props => props.column.id
      },
      {
        accessorFn: row => <>
          <a onClick={() => copyWorkOrder(row.work_order_id)} href="javascript:void(0)" className="btn btn-link ">Copy</a>

          <a onClick={() => reOpenWorkOrder(row.work_order_id)} href="javascript:void(0)" className="btn btn-link " >Re-open</a>
          <a onClick={() => deleteWorkOrder(row.work_order_id)} href="javascript:void(0)" className="btn btn-link " >Delete</a>

        </>,
        id: "actions",
        cell: info => info.getValue(),
        header: () => "ACTIONS",
        footer: props => props.column.id,
        enableColumnFilter: false,
        enableSorting: false,
      }


    ],
    []
  )


  const [data, setData] = React.useState(null);

  const getWorkOrders = async () => {

    await axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-canceled-work-orders", {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          setData(response?.data?.work_orders);

        } else {


          Swal.fire({ icon: "error", title: "Canceled Work Order Failed to Load", text: response?.data?.message });

        }

      })
      .catch(function (error) {

        if (error.status == 403) {

          Swal.fire({ icon: "error", title: "Session Expired", text: error.message });
          navigate("/login");
        }
        else {

          Swal.fire({ icon: "error", title: "Canceled Work Order Failed", text: error.message });

        }

      });

  }



  const copyWorkOrder = async (work_order_id) => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/copy-work-order", {
      work_order_id: work_order_id
    }, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          getWorkOrders();
          Swal.fire({ icon: "success", title: "Work order copied successfully. " });


        } else {

          Swal.fire({ icon: "error", title: "Unable to copy work order " });

        }

      })
      .catch(function (error) {

        catchError(error, navigate)

      });


  }

  const reOpenWorkOrder = async (work_order_id) => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/re-open-work-order", {
      work_order_id: work_order_id
    }, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          getWorkOrders();

        } else {

          Swal.fire({ icon: "error", title: "Unable to reopen work order" });

        }

      })
      .catch(function (error) {

        catchError(error, navigate)

      });


  }




  const deleteWorkOrder = async (work_order_id) => {

    Swal.fire({
      title: "Are you sure, you want to delete this?",
      text: "You won't be able to revert this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/delete-work-order",
          { work_order_id: work_order_id },
          {
            withCredentials: true
          })
          .then(function (response) {

            if (response?.data?.status) {

              Swal.fire({ icon: "success", title: "Deleted", text: "Work order MRA-" + work_order_id + " deleted successfully." });

              getWorkOrders(response?.data?.work_orders);

            } else {

              Swal.fire({ icon: "error", title: "Unable to delete work order", text: response?.data?.message });

            }

          })
          .catch(function (error) {

            catchError(error, navigate)
          });

      }
    });

  }
  useEffect(() => {

    getWorkOrders();

  }, []);

  return (
    <>




      <div className="row py-2 start-0 bg-light">

        <div className="col-md-12 col-sm-12 mx-auto text-center">
          <div className="container-fluid z-2  ">

            <span className="btn btn-warning rounded-0 me-1">
              <NavLink className="nav-link" smooth to="/admin/work-orders-active">
                ACTIVE
              </NavLink>
            </span>
             { localStorage.getItem('@is_super_admin') == 1 &&
           <>                            
            <span className="btn btn-warning rounded-0 me-1">
              <NavLink className="nav-link" smooth to="/admin/work-orders-invoice-needed">
                INVOICE NEEDED
              </NavLink>
            </span>
            <span className="btn btn-warning rounded-0  me-1 ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-records-obtained">
                RECORDS OBTAINED
              </NavLink>
            </span>

            <span className="btn btn-warning rounded-0  me-1 ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-closed">
                CLOSED
              </NavLink>
            </span>

            <span className="btn btn-warning rounded-0  me-1 ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-archived">
                ARCHIVED
              </NavLink>
            </span>
</>
}
            <span className="btn btn-success rounded-0  me-1 ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-canceled">
                CANCELED
              </NavLink>
            </span>

            <span className="btn btn-warning rounded-0 me-1 ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-incomplete">
                INCOMPLETE
              </NavLink>
            </span>
            <span className="btn btn-warning rounded-0  ">
                          <NavLink className="nav-link" smooth to="/admin/work-orders-missing">
                            MISSING
                          </NavLink>
                        </span>
          </div>
        </div>
      </div>


      <div className="row py-4 start-0  mx-auto ">

        <div className="col-md-6 col-sm-12  ">
          <h3 className="text-dark my-0">CANCELED WORK ORDERS (500 MOST RECENT)</h3>
        </div>

        <div className="col-md-6 col-sm-12 ps-3 text-end">

          <span className="btn btn-primary rounded-0 me-1">
            <NavLink className="nav-link" smooth to="/admin/work-orders-new">
              NEW
            </NavLink>
          </span>
          <span className="btn btn-danger rounded-0  me-1 ">
            <NavLink className="nav-link" smooth to="/admin/work-orders-search">
              SEARCH
            </NavLink>
          </span>

        </div>

      </div>




      {data &&


        <div className="card border-4 border-dark rounded-1 card-success mb-4" >

          <div className="card-body p-0" >

            <CustomTable columns={columns} data={data} />

          </div>
        </div>


      }
    </>

  );
};

export default Canceled;